import styles from "./ProgressPieChart.module.css";

interface Props {
  percentage: number;
}

export function ProgressPieChart(props: Props) {
  const { percentage } = props;

  const style = {
    "--progress": `${percentage}%`,
  } as React.CSSProperties;

  return (
    <div className={styles.progressFill} style={style}>
      <div className={styles.progressBorder}>
        <div className={styles.progressPieChart} />
      </div>
    </div>
  );
}
